// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck

import { Button, IconButton, List, ListItem, ListItemText, Paper, Typography } from '@mui/material'
import DeleteIcon from '@mui/icons-material/Delete'
import EditIcon from '@mui/icons-material/Edit'
import get from 'lodash/get'
import React from 'react'
import { Mutation, Query } from 'react-apollo'
import Loader from '../../../common/loader/Loader'
import { i18n } from '../../index'
import CheckQuestionDialog from './CheckQuestionDialog'
import css from './chainCheckQuestion.css'
import {
  chainCheckQuestionsQuery,
  createChainCheckQuestionMutation,
  deleteChainCheckQuestionMutation,
  updateChainCheckQuestionMutation,
} from './checkQuestionQueries'

// The 5 check types, in display order. Labels reuse the checklistType keys.
const CHECK_TYPES = ['toilet', 'buffet', 'vitrine', 'hall', 'market']

type CheckQuestion = {
  id: string
  type: string
  description: string
}

type State = {
  isDialogOpen: boolean
  dialogType: string
  editData: CheckQuestion | null
}

class ChainCheckQuestionSection extends React.Component<Record<string, never>, State> {
  state = {
    isDialogOpen: false,
    dialogType: 'toilet',
    editData: null,
  }

  openCreate = (type: string) => {
    this.setState({ isDialogOpen: true, dialogType: type, editData: null })
  }

  openEdit = (question: CheckQuestion) => {
    this.setState({ isDialogOpen: true, dialogType: question.type, editData: question })
  }

  closeDialog = () => {
    this.setState({ isDialogOpen: false, editData: null })
  }

  groupByType = (questions: CheckQuestion[]) => {
    return questions.reduce(
      (acc, q) => {
        if (!acc[q.type]) {
          acc[q.type] = []
        }
        acc[q.type].push(q)
        return acc
      },
      {} as Record<string, CheckQuestion[]>,
    )
  }

  render() {
    const { isDialogOpen, dialogType, editData } = this.state
    return (
      <Paper>
        <div className={css.wrapper}>
          <div className={css.top}>
            <Typography variant='h6'>{i18n.t('admin.checkQuestions.pageTitle')}</Typography>
          </div>
          <Query query={chainCheckQuestionsQuery} fetchPolicy='network-only'>
            {({ loading, error, data }) => {
              const questions = get(data, 'chainCheckQuestions', [])
              const grouped = this.groupByType(questions)
              return (
                <Loader {...{ loading, error }}>
                  {CHECK_TYPES.map((type) => (
                    <div key={type} className={css.group}>
                      <div className={css.groupHeader}>
                        <Typography variant='subtitle1'>{i18n.t(`checkList.checklistType.${type}`)}</Typography>
                        <Button size='small' variant='outlined' color='primary' onClick={() => this.openCreate(type)}>
                          {i18n.t('admin.checkQuestions.addQuestion')}
                        </Button>
                      </div>
                      <List dense>
                        {(grouped[type] || []).map((q) => (
                          <ListItem key={q.id} divider className={css.item}>
                            <ListItemText primary={q.description} />
                            <IconButton size='small' onClick={() => this.openEdit(q)} aria-label='edit'>
                              <EditIcon fontSize='small' />
                            </IconButton>
                            <Mutation
                              mutation={deleteChainCheckQuestionMutation}
                              refetchQueries={[{ query: chainCheckQuestionsQuery }]}
                            >
                              {(onDelete) => (
                                <IconButton
                                  size='small'
                                  aria-label='delete'
                                  onClick={() => onDelete({ variables: { id: q.id } })}
                                >
                                  <DeleteIcon fontSize='small' />
                                </IconButton>
                              )}
                            </Mutation>
                          </ListItem>
                        ))}
                      </List>
                    </div>
                  ))}
                </Loader>
              )
            }}
          </Query>
        </div>
        <CheckQuestionDialog
          isOpen={isDialogOpen}
          type={dialogType}
          data={editData}
          createMutation={createChainCheckQuestionMutation}
          updateMutation={updateChainCheckQuestionMutation}
          refetchQuery={chainCheckQuestionsQuery}
          onClose={this.closeDialog}
        />
      </Paper>
    )
  }
}

export default ChainCheckQuestionSection
